module.exports = __webpack_public_path__ + "static/img/app.3ebc9a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/app.png
// module id = PRH0
// module chunks = 1